export default {
  name: "Birra Moretti",
  favicon: `${process.env.REACT_APP_AZURE_STORAGE}/birramoretti/logo.webp`,
  logo: `${process.env.REACT_APP_AZURE_STORAGE}/birramoretti/logo.webp`,
  logoColor: `${process.env.REACT_APP_AZURE_STORAGE}/birramoretti/logo-color.webp`,
  products: [
    {
      id: "birramoretti",
      image: {
        en: `${process.env.REACT_APP_AZURE_STORAGE}/birramoretti/en/product_forward_birramoretti.webp`,
        fr: `${process.env.REACT_APP_AZURE_STORAGE}/birramoretti/fr/product_forward_birramoretti.webp`,
      },
      name: {
        en: "Lager",
        fr: "Lager",
      },
      description: {
        en: "An authentically Italian quality lager brewed with passion and the finest quality ingredients, with the same recipe since 1859. A special blend of quality hops creates a well balanced lager with some hoppy and fruity notes, finished with moderate bitterness and a clean aftertaste.",
        fr: "Une lager de qualité, authentiquement italienne et brassée avec passion et les meilleurs ingrédients, selon la même recette depuis 1859. Un mélange spécial de houblons de qualité crée une lager bien équilibrée avec des notes houblonnées et fruitées, qui se termine par une amertume modérée et un arrière-goût net.",
      },
      formats: [
        {
          image: {
            en: `${process.env.REACT_APP_AZURE_STORAGE}/birramoretti/en/information_render_can_330ml_birramoretti.webp`,
            fr: `${process.env.REACT_APP_AZURE_STORAGE}/birramoretti/fr/information_render_can_330ml_birramoretti.webp`,
          },
          details: {
            en: `${process.env.REACT_APP_AZURE_STORAGE}/birramoretti/en/information_nft_allrenders_birramoretti.webp`,
            fr: `${process.env.REACT_APP_AZURE_STORAGE}/birramoretti/fr/information_nft_allrenders_birramoretti_fr.webp`,
          },
          name: {
            en: "Can 330ml",
            fr: "Canette 330ml",
          },
        },
        {
          image: {
            en: `${process.env.REACT_APP_AZURE_STORAGE}/birramoretti/en/information_render_can_500ml_birramoretti.webp`,
            fr: `${process.env.REACT_APP_AZURE_STORAGE}/birramoretti/fr/information_render_can_500ml_birramoretti.webp`,
          },
          details: {
            en: `${process.env.REACT_APP_AZURE_STORAGE}/birramoretti/en/information_nft_allrenders_birramoretti.webp`,
            fr: `${process.env.REACT_APP_AZURE_STORAGE}/birramoretti/fr/information_nft_allrenders_birramoretti_fr.webp`,
          },
          name: {
            en: "Can 500ml",
            fr: "Canette 500ml",
          },
        },
        {
          image: {
            en: `${process.env.REACT_APP_AZURE_STORAGE}/birramoretti/en/information_render_bottle_330ml_birramoretti.webp`,
            fr: `${process.env.REACT_APP_AZURE_STORAGE}/birramoretti/fr/information_render_bottle_330ml_birramoretti.webp`,
          },
          details: {
            en: `${process.env.REACT_APP_AZURE_STORAGE}/birramoretti/en/information_nft_allrenders_birramoretti.webp`,
            fr: `${process.env.REACT_APP_AZURE_STORAGE}/birramoretti/fr/information_nft_allrenders_birramoretti_fr.webp`,
          },
          name: {
            en: "Bottle 330ml",
            fr: "Bouteille 330ml",
          },
        },
      ],
    },
  ],
};
